export class SysWxconfig{
    constructor(){
       this.debug=false;
       this.jsApiList=new Array<string>();
    }
    /**
     *  开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
     *  是否启用debug模式,默认 false;
     */
    debug:boolean;
    /**
     * 必填，企业号的唯一标识，此处填写企业号corpid
     */
    appId:string;
    /**
     * 必填，生成签名的时间戳;
     */
    timestamp:number;
    /**
     * 必填，生成签名的随机串
     */
    nonceStr:string;
    /**
     *  必填，签名
     */
    signature:string;
    /**
     * 必填，需要使用的JS接口列表，所有JS接口列表参考微信接口
     */
    jsApiList:Array<string>;

}